<template>
  <div class="container">
    <h1 class="page-title">GAC LOADER</h1>
    <br />

    <div>
      <table class="data-table" id="mytable">
        <thead>
          <tr>
            <th>SN</th>
            <th>Meeting</th>
            <th>Start Date</th>
            <th>Finish Date</th>
            <th>Occurrence</th>
            <th>Start Time</th>
            <th>Finish Time</th>
            <th>Message</th>
            <th>Assigned To</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody :key="tablekey">
          <!-- <tr v-for="(cal, index) in form" :key="index">
            <td>{{ index+1 }}</td>
            <td>{{ cal.meeting_id }}</td>
            <td>{{ cal.start_date }}</td>
            <td>{{ cal.finish_date }}</td>
            <td>{{ cal.occurance }}</td>
            <td>{{ cal.start_time }}</td>
            <td>{{ cal.finish_time }}</td>
            <td>{{ cal.message }}</td>
            <td>{{ cal.assigned_to }}</td>
            <td><button @click.prevent="updateData(index, cal)">Update</button></td>
          </tr> -->
        </tbody>
      </table>
    </div>

    <button
      class="form-button"
      style="background-color: green"
      v-if="!uploadingContent"
      @click.prevent="storeMeeting"
    >
      Submit
    </button>
    <p v-if="uploadingContent">uploading <span class="loader"></span></p>

    <!-- Render each form -->
    <hr />
    <form @submit.prevent="handleSubmit">
      <div class="form-fields">
        <div>
          <label for="meeting_id">Meeting</label><br />
          <input
            v-model="meeting_id"
            type="text"
            id="meeting_id"
            class="input-field"
            placeholder="Input meeting"
            required
          />
        </div>

        <div>
          <label for="start_date">Start Date</label><br />
          <input
            v-model="start_date"
            type="date"
            id="start_date"
            class="input-field"
            required
          />
        </div>

        <div>
          <label for="finish_date">Finish Date</label><br />
          <input
            v-model="finish_date"
            type="date"
            id="finish_date"
            class="input-field"
            required
          />
        </div>

        <div>
          <label for="occurance">Occurrence</label><br />
          <select
            v-model="occurance"
            id="occurance"
            class="input-field"
            required
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="annual">Annual</option>
          </select>
        </div>

        <div>
          <label for="start_time">Start Time</label><br />
          <input
            v-model="start_time"
            type="time"
            id="start_time"
            class="input-field"
            required
          />
        </div>

        <div>
          <label for="finish_time">Finish Time</label><br />
          <input
            v-model="finish_time"
            type="time"
            id="finish_time"
            class="input-field"
            required
          />
        </div>

        <div>
          <label for="message">Message</label><br />
          <input
            v-model="message"
            type="text"
            id="message"
            class="input-field"
            placeholder="Message"
            required
          />
        </div>

        <div>
          <label for="assigned_to">Assigned To</label><br />
          <input
            v-model="assigned_to"
            type="text"
            id="assigned_to"
            class="input-field"
            placeholder="Assigned to"
            required
          />
        </div>

        <button class="form-button" v-if="!updateMode">Add Form</button>
        <button class="form-button" v-if="updateMode">Update</button
        ><br /><br />

        <lable>Upload CSV File</lable> :
        <input
          type="file"
          class="bg-red-800 p-2 w-full mt-2 text-gray-200 hover:bg-red-900 border rounded-md"
          @change="handleFileUpload"
        />
      </div>
    </form>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import axios from "axios";
import $ from "jquery";
import "datatables.net";

const meeting_id = ref("");
const start_date = ref("");
const finish_date = ref("");
const occurance = ref("");
const start_time = ref("");
const finish_time = ref("");
const message = ref("");
const assigned_to = ref("");
const form = ref([]);
const updateMode = ref(false);
const id = ref(0);
const csvfile = ref();
const tablekey = ref(0);
const uploadingContent = ref(false);

const handleFileUpload = async (event) => {
  const file = event.target.files[0];
  csvfile.value = file;
  const formdata = new FormData();
  formdata.append("gac_template", csvfile.value);

  const { status, data } = await axios.post(
    `${url.value}/api/upload-gac`,
    formdata
  );

  if (status === 200) {
    data.data.forEach((element) => {
      const formData = {
        meeting_id: element["TITLE OF MEETING"],
        start_date: element["START DATE"],
        finish_date: element["END DATE"],
        occurance: element["OCCURENCE"],
        start_time: element["START TIME"],
        finish_time: element["END TIME"],
        message: element["MESSAGE"],
        assigned_to: element["ASSIGNED TO"],
      };

      localStorage.setItem("data", formData);

      form.value.push(formData);
    });

    datatable();
  }
};

const submitForm = () => {
  const formData = {
    meeting_id: meeting_id.value,
    start_date: start_date.value,
    finish_date: finish_date.value,
    occurance: occurance.value,
    start_time: start_time.value,
    finish_time: finish_time.value,
    message: message.value,
    assigned_to: assigned_to.value,
  };

  localStorage.setItem("data", formData);

  form.value.push(formData);
  tablekey.value++;
  clearForm(); // Optional: Clear the form fields after submitting
};

const datatable = () => {
  // Initialize DataTable with your data
  $("#mytable").DataTable({
    paging: true, // Enable pagination
    searching: true, // Enable search
    ordering: true, // Enable sorting
    data: form.value, // Use the data from your ref
    columns: [
      { data: null, render: (data, type, row, meta) => meta.row + 1 },
      { data: "meeting_id" },
      { data: "start_date" },
      { data: "finish_date" },
      { data: "occurance" },
      { data: "start_time" },
      { data: "finish_time" },
      { data: "message" },
      { data: "assigned_to" },
      {
        data: null,
        render: (data, type, row, meta) =>
          `<button onclick="updateData(${meta.row})">Update</button>`,
      },
    ],
    // Add more options here as needed
  });
};

const clearForm = () => {
  meeting_id.value = "";
  start_date.value = "";
  finish_date.value = "";
  occurance.value = "";
  start_time.value = "";
  finish_time.value = "";
  message.value = "";
  assigned_to.value = "";
};

const url = ref();

const storeMeeting = async () => {
  uploadingContent.value = true;
  await axios.post(`${url.value}/api/meeting/mass/upload`, form.value);
  uploadingContent.value = false;
  window.location.reload();
};

window.updateData = (index) => {
  updateMode.value = true;
  const data = form.value[index];
  id.value = index;
  meeting_id.value = data.meeting_id;
  start_date.value = data.start_date;
  finish_date.value = data.finish_date;
  occurance.value = data.occurance;
  start_time.value = data.start_time;
  finish_time.value = data.finish_time;
  message.value = data.message;
  assigned_to.value = data.assigned_to;
};

const update = () => {
  // Ensure there is a valid index to update
  if (id.value >= 0 && id.value < form.value.length) {
    form.value[id.value] = {
      meeting_id: meeting_id.value,
      start_date: start_date.value,
      finish_date: finish_date.value,
      occurance: occurance.value,
      start_time: start_time.value,
      finish_time: finish_time.value,
      message: message.value,
      assigned_to: assigned_to.value,
    };

    // Clear the form fields
    clearForm();

    // Set updateMode back to false to allow adding new forms
    updateMode.value = false;
  }
};

const settings = ref();
const getUrl = () => {
  // If settings are available in localStorage, load them
  const storedSettings = localStorage.getItem("settings");
  if (storedSettings) {
    settings.value = JSON.parse(storedSettings);
    url.value = settings.value.defaultStates[0].gac;
  }
  if (!url.value) {
    url.value = "https://ccs.suburbanfiberco.com";
  }
};

onMounted(() => {
  getUrl();
});

const handleSubmit = () => {
  if (!updateMode.value) {
    submitForm();
  } else {
    update();
  }
};
</script>

<style>
/* Add your CSS styles in a separate stylesheet or <style> block */
.container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
}

.data-table th,
.data-table td {
  border: 1px solid black;
  padding: 10px;
  text-align: left;
}

.form-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
}

.form-fields {
  margin-top: 20px;
}

.input-field {
  width: 40%;
  padding: 5px;
  margin: 5px 0;
  border: 1px solid #ccc;
}

.loader {
  width: 10px;
  height: 10Zpx;
  border: 2px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
